
import * as defaultImport from "lodash/isString";
export * from "lodash/isString";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
